export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13879.eb6e20b2.jpg";